/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_Feat4Inputs */

const en_fac_plan_feat4 = /** @type {(inputs: Fac_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything in Pro (15 PRDs & 120 agent messages/mo)`)
};

const id_fac_plan_feat4 = /** @type {(inputs: Fac_Plan_Feat4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua fitur Pro (15 PRD & 120 pesan agent/bln)`)
};

/**
* | output |
* | --- |
* | "Everything in Pro (15 PRDs & 120 agent messages/mo)" |
*
* @param {Fac_Plan_Feat4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_feat4 = /** @type {((inputs?: Fac_Plan_Feat4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_Feat4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_feat4(inputs)
	return en_fac_plan_feat4(inputs)
});